import api from './api'

export interface ControlTowerItem {
  id: string
  kind: 'quote' | 'order'
  stage: 'awaiting_offers' | 'receiving_offers' | 'closed' | 'in_transit' | 'delivered'
  txControl: string
  shipperName: string
  agentName: string | null
  tenantName: string
  modality: string | null
  offersCount: number | null
  totalValue: number | null
  currency: string | null
  createdAt: string
  updatedAt: string
}

export async function getControlTower(): Promise<{ items: ControlTowerItem[]; generatedAt: string }> {
  const res = await api.get('/master/control-tower')
  return res.data
}
